import type { TranslationTree } from '../../types';

export const errors: TranslationTree = {
  errors: {
    // Erreurs génériques
    unknown: "Une erreur inattendue s'est produite. Veuillez réessayer.",
    generic: "Une erreur s'est produite. Veuillez réessayer.",

    // Erreurs réseau
    network: {
      generic: 'Erreur réseau. Veuillez vérifier votre connexion.',
      fetchFailed:
        'Impossible de se connecter au serveur. Veuillez vérifier votre connexion Internet.',
      requestFailed: 'La requête réseau a échoué. Veuillez réessayer.',
      timeout: 'La requête a pris trop de temps. Veuillez réessayer.',
    },

    // Erreurs API
    api: {
      unknown: "Une erreur inattendue s'est produite. Veuillez réessayer.",
      badRequest: 'Requête invalide. Veuillez vérifier vos données et réessayer.',
      notFound: "La ressource demandée n'a pas été trouvée.",
      conflict: "Un conflit s'est produit. La ressource a peut-être été modifiée.",
      validationFailed: 'Validation échouée. Veuillez vérifier vos données.',
      rateLimited: 'Trop de requêtes. Veuillez attendre un moment et réessayer.',
      serverError: "Une erreur serveur s'est produite. Veuillez réessayer plus tard.",
      badGateway: 'Erreur de passerelle. Veuillez réessayer plus tard.',
      unavailable: 'Service temporairement indisponible. Veuillez réessayer plus tard.',
      gatewayTimeout: "Délai d'expiration de la passerelle. La requête a pris trop de temps.",
      timeout: "Délai d'expiration de la requête. Veuillez réessayer.",
      loadFailed: 'Échec du chargement des données. Veuillez réessayer.',
      saveFailed: "Échec de l'enregistrement des données. Veuillez réessayer.",
      deleteFailed: 'Échec de la suppression. Veuillez réessayer.',
      updateFailed: 'Échec de la mise à jour. Veuillez réessayer.',
    },

    // Erreurs d'authentification
    auth: {
      unauthorized: 'Non autorisé. Veuillez vous connecter.',
      forbidden: "Accès refusé. Vous n'avez pas les permissions nécessaires.",
      authenticationFailed: "Échec de l'authentification. Veuillez vérifier vos identifiants.",
      invalidCredentials: 'Email ou mot de passe invalide. Veuillez réessayer.',
      sessionExpired: 'Votre session a expiré. Veuillez vous reconnecter.',
      permissionDenied: "Vous n'avez pas la permission d'effectuer cette action.",
    },

    // Erreurs de validation
    validation: {
      required: 'Ce champ est requis.',
      fieldRequired: 'Le champ {{field}} est requis.',
      emailInvalid: 'Veuillez entrer une adresse email valide.',
      emailRequired: "L'email est requis.",
      passwordRequired: 'Le mot de passe est requis.',
      passwordTooShort: 'Le mot de passe doit contenir au moins 8 caractères.',
      passwordWeak: 'Le mot de passe est trop faible. Utilisez majuscules, minuscules et chiffres.',
      tooShort: 'Cette valeur est trop courte.',
      fieldTooShort: 'Le champ {{field}} est trop court.',
      tooLong: 'Cette valeur est trop longue.',
      fieldTooLong: 'Le champ {{field}} est trop long.',
      invalidFormat: 'Format invalide.',
      mustMatch: 'Les valeurs ne correspondent pas.',
    },

    // Erreurs caméra
    camera: {
      generic: 'Erreur caméra. Veuillez réessayer.',
      notFound: 'Aucun périphérique caméra trouvé. Veuillez vérifier votre connexion caméra.',
      permissionDenied:
        'Accès à la caméra refusé. Veuillez autoriser les permissions de la caméra.',
      inUse: 'La caméra est déjà utilisée par une autre application.',
      constraintFailed: "Les contraintes de la caméra n'ont pas pu être satisfaites.",
      accessFailed: "Échec de l'accès à la caméra. Veuillez réessayer.",
    },

    // Erreurs de données
    data: {
      parseFailed: "Échec de l'analyse des données. Le format des données peut être invalide.",
      processingFailed: 'Échec du traitement des données. Veuillez réessayer.',
      invalidFormat: 'Format de données invalide.',
    },

    // Limites d'erreur (error boundaries)
    boundary: {
      title: 'Une erreur est survenue',
      description:
        "L'application a rencontré une erreur inattendue et doit être rechargée. Nous nous excusons pour la gêne occasionnée.",
      reloadApp: "Recharger l'application",
      tryAgain: 'Réessayer',
      goBack: 'Retour',
      goHome: 'Accueil',
      contactSupport: 'contacter le support',
      persistsPrefix: 'Si ce problème persiste, veuillez',
      errorDetails: "Détails de l'erreur (développement uniquement) :",
      componentStack: 'Pile des composants',
      stackTrace: 'Trace de la pile',
      featureDescription: 'Une erreur est survenue dans le module {{feature}}. Veuillez réessayer.',
    },

    // Suggestions d'actions
    actions: {
      retry: 'Veuillez réessayer.',
      pleaseLogin: 'Veuillez vous connecter pour continuer.',
      contactAdmin: 'Veuillez contacter votre administrateur.',
      checkUrl: "Veuillez vérifier l'URL et réessayer.",
      waitAndRetry: 'Veuillez attendre un moment et réessayer.',
      tryAgainLater: 'Veuillez réessayer plus tard.',
      checkConnection: 'Veuillez vérifier votre connexion Internet.',
      checkCameraPermission:
        'Veuillez vérifier les permissions de la caméra dans les paramètres de votre navigateur.',
      reload: 'Veuillez recharger la page.',
      goBack: 'Veuillez revenir en arrière et réessayer.',
    },
  },
};
